import React, { useState, useEffect, useCallback, useContext } from 'react';
import { withTranslation } from '../../ChildrenContext.js';
import PropTypes from 'prop-types';
import CustomModal from '../../Modal';
import CustomTooltip from "../../Tooltip";
import ClipboardCopy from "../../../helpers/ClipboardCopy";
import CustomNotify from "../../Notify";
import config from "../../../config";

const creativeType = 'promocode';

const PromoCodeListConstructorComponent = ({
    offer: propOffer,
    goalEntryId: propGoalEntryId,
    linkId: propLinkId,
    visible: propVisible,
    access: propAccess,
    type: propType,
    creativeType: propCreativeType,
    creativeId: propCreativeId,
    link: propLink,
    goalEntries: propGoalEntries,
    publisherId: propPublisherId,
    promocode: propPromocode,
    codeParams: propCodeParams,
    promoTitle: propPromoTitle,
    description: propDescription,
    errors: propErrors,
    getDataLink: propGetDataLink,
    onClose: propOnClose,
    deletePromoCode: propDeletePromoCode,
    onEdit: propOnEdit,
    showConstructorPromoCode: propShowConstructorPromoCode,
    t
}) => {
    const [state, setState] = useState({
        creativeType: propCreativeType || creativeType,
        creativeId: propCreativeId || propLinkId,
        linkId: propLinkId || (propLink && propLink.id) || '',
        link: propLink,
        modalIsVisible: propVisible,
        goalEntries: propGoalEntries,
        publisherId: propPublisherId,
        metaParams: {},
        selfieLink: '',
        currentLinkId: '',
        resultLink: '',
        type: propType,
        codeParams: propCodeParams || {},
        promoTitle: propPromocode && propPromocode.title ? propPromocode.title : "",
        description: propPromocode && propPromocode.description ? propPromocode.description : "",
        errors: propErrors || '',
        goalEntryId: propGoalEntryId || null,
        access: !!propGoalEntryId && propAccess
    });

    const staticNames = t?.constructors || {};
    const modalOptions = {
        promocode: {
            title: staticNames.promocodes,
            pattern: '{{ promocode }}'
        },
        container: {
            title: staticNames.promocodes,
            pattern: '<iframe src="{{ promocode }}" width="{{ width }}" height="{{ height }}" align="middle">{{ text }}</iframe>'
        }
    };

    const getFirstGoal = useCallback(() => {
        let goal = state.goalEntries ? (state.goalEntries.find(g => g.access_granted) || {}) : {};
        return goal.id;
    }, [state.goalEntries]);

    const successLink = useCallback((data) => {
        setState(prevState => ({
            ...prevState,
            link: data
        }));
    }, []);

    const resolvedLinkId = propLinkId || (propLink && propLink.id);

    const initLink = useCallback(() => {
        if (!resolvedLinkId) {
            return;
        }
        propGetDataLink(resolvedLinkId, successLink);
    }, [resolvedLinkId, propGetDataLink, successLink]);

    const close = useCallback(() => {
        propOnClose();
    }, [propOnClose]);

    const onClickEditPromoCode = useCallback((linkId, promocode) => {
        if (propShowConstructorPromoCode) {
            propOnClose();
            propShowConstructorPromoCode({
                linkId: linkId,
                promocode: promocode,
                creativeType: 'promocode',
                creativeId: promocode.id || state.creativeId,
                goalEntryId: state.goalEntryId || promocode.goalEntryId || propGoalEntryId,
                type: 'promocode',
                codeParams: state.codeParams,
                access: state.access,
                returnToPromoCodeList: true
            });
        } else if (propOnEdit) {
            propOnEdit({
                linkId: linkId,
                promocode: promocode
            });
        }
    }, [propShowConstructorPromoCode, propOnEdit, propOnClose, propGoalEntryId, state.goalEntryId, state.codeParams, state.access, state.creativeId]);

    const unsecuredCopyToClipboard = useCallback((id) => {
        var elem = document.getElementById(id+'_clip');
        elem.select();

        try {
            document.execCommand("copy");
            CustomNotify(elem.value);
        } catch(err){
            console.error('Unable to copy to clipboard', err);
        }
    }, []);

    const copyToClipboard = useCallback((id, promoCode) => {
        if (window.isSecureContext && navigator.clipboard) {
            navigator.clipboard.writeText(promoCode);
            CustomNotify(promoCode);
        } else {
            unsecuredCopyToClipboard(id);
        }
    }, [unsecuredCopyToClipboard]);

    const onClickDeletePromoCode = useCallback((promoCodeId) => {
        let link = state.link;
        if (link.promo_codes && Array.isArray(link.promo_codes)) {
            link.promo_codes = link.promo_codes.filter((promoCode) => promoCode.id !== promoCodeId);
        }

        setState(prevState => ({
            ...prevState,
            link: link
        }));

        propDeletePromoCode(promoCodeId, t, () => {}, () => {});
    }, [state.link, propDeletePromoCode, t]);

    useEffect(() => {
        initLink();
    }, [initLink]);

    useEffect(() => {
        if (propVisible) {
            initLink();
        }
    }, [propVisible, initLink]);

    useEffect(() => {
        const isChangeLinkId = state.linkId !== resolvedLinkId;
        let promoTitle = propPromocode ? propPromocode.title : "";
        let description = propPromocode ? propPromocode.description : "";

        setState(prevState => ({
            ...prevState,
            creativeType: propCreativeType || creativeType,
            creativeId: propCreativeId || resolvedLinkId,
            linkId: resolvedLinkId,
            goalEntries: propGoalEntries,
            publisherId: propPublisherId,
            link: propLink,
            promocode: propPromocode,
            type: propType,
            selfieLink: '',
            codeParams: propCodeParams || {},
            access: !!getFirstGoal() && propAccess,
            modalIsVisible: propVisible,
            promoTitle: propPromoTitle || promoTitle,
            description: propDescription || description,
            errors: propErrors,
            goalEntryId: propGoalEntryId || getFirstGoal()
        }));

        if (isChangeLinkId) {
            initLink();
        }
    }, [propCreativeType, propCreativeId, resolvedLinkId, propGoalEntries, propPublisherId, propLink, propPromocode, propType, propCodeParams, propAccess, propVisible, propPromoTitle, propDescription, propErrors, propGoalEntryId, getFirstGoal, initLink, state.linkId]);

    if(undefined === modalOptions[state.type] || undefined === state.link) {
        return '';
    }

    if ("object" === typeof state.link && 0 === Object.keys(state.link).length && state.modalIsVisible) {
        return '';
    }

    let options = modalOptions[state.type];
    let editPromoCode = false;

    return (
        <div className="promocode-construrtor">
            <CustomModal
                visible={state.modalIsVisible}
                onClose={propOnClose}
                onConfirm={editPromoCode ? () => {} : () => {}}
                confirmName={staticNames.save}
                title={staticNames.promocodes}
                bsSize={'sm'}
                className={'modal__promo_list'}
                areNoControls={true}
                disableHistoryTracking={true}
            >
                <div className="offer-item__promo-links-wrap">
                    <div className="link-title"><span>{state.link.title}</span></div>
                    <div className="link-url"><span>{state.link.url}</span></div>
                    <div className="promo-code-tree">
                        {state.link.promo_codes && Array.isArray(state.link.promo_codes) && state.link.promo_codes.length > 0
                            ? state.link.promo_codes.map((promoCode, key) => (
                                <div className="promo-code-tree__item" key={key}>
                                    <div className="item-desc" data-index={promoCode.id}>
                                        <span>{promoCode.title}</span><br/>
                                        <span className="item-desc__description">{promoCode.description}</span>
                                    </div>
                                    <div className="item_actions d-flex justify-content-evenly">
                                        <CustomTooltip
                                            containerClassName='control-item'
                                            id={`${promoCode.id}_copy_tooltip`}
                                            tooltip={t?.constructors?.copy}
                                        >
                                            <a data-index={promoCode.id}
                                               onClick={() => {copyToClipboard(promoCode.id, promoCode.title)}}
                                            >
                                                <span className="fa fa-copy" />
                                            </a>
                                            <input id={`${promoCode.id}_clip`}
                                                   value={promoCode.title}
                                                   style={{position: 'fixed', top: '-500px', left: '-200px'}}
                                            />
                                        </CustomTooltip>
                                        <CustomTooltip
                                            id={`${promoCode.id}_edit_tooltip`}
                                            tooltip={t?.actions?.edit}
                                        >
                                            <a className="control-item"
                                               data-index={promoCode.id}
                                               href="#"
                                               onClick={(e) => {
                                                   e.preventDefault();
                                                   if (state.link && state.link.id) {
                                                       onClickEditPromoCode(state.link.id, promoCode);
                                                   }
                                               }}
                                            >
                                                <span className={config.allowGeneratePromocodes ? "fa fa-pencil-square-o" : "fa fa-eye"} />
                                            </a>
                                        </CustomTooltip>
                                        {(() => {
                                            if (config.allowGeneratePromocodes) {
                                                return <CustomTooltip
                                                    id={`${promoCode.id}_delete_tooltip`}
                                                    tooltip={t?.actions.delete}
                                                >
                                                    <a className="control-item"
                                                       data-index={promoCode.id}
                                                       onClick={() => { onClickDeletePromoCode(promoCode.id); }}
                                                    >
                                                        <span className="fa fa-trash-o" />
                                                    </a>
                                                </CustomTooltip>
                                            }
                                        })()}
                                    </div>
                                </div>
                            ))
                            : null
                        }
                    </div>
                </div>
            </CustomModal>
        </div>
    );
};

PromoCodeListConstructorComponent.propTypes = {
    offer: PropTypes.object.isRequired,
    goalEntryId: PropTypes.string,
    linkId: PropTypes.string,
    visible: PropTypes.bool,
    access: PropTypes.bool,
    type: PropTypes.string,
    creativeType: PropTypes.string,
    creativeId: PropTypes.string,
    link: PropTypes.object,
    goalEntries: PropTypes.array,
    publisherId: PropTypes.string,
    promocode: PropTypes.object,
    codeParams: PropTypes.object,
    promoTitle: PropTypes.string,
    description: PropTypes.string,
    errors: PropTypes.string,
    getDataLink: PropTypes.func,
    onClose: PropTypes.func,
    deletePromoCode: PropTypes.func,
    onEdit: PropTypes.func,
    showConstructorPromoCode: PropTypes.func,
    t: PropTypes.object
};

PromoCodeListConstructorComponent.defaultProps = {
    type: creativeType,
    creativeType: creativeType,
    creativeId: '',
    link: {},
    goalEntries: [],
    publisherId: '',
    promocode: {},
    codeParams: {},
    promoTitle: '',
    description: '',
    errors: '',
    getDataLink: () => {},
    onClose: () => {},
    deletePromoCode: () => {},
    onEdit: () => {},
    showConstructorPromoCode: () => {}
};

export default withTranslation(PromoCodeListConstructorComponent);
